// Display labels for the pricing-result keys the pricing engine emits, shared by the price-breakdown and
// pricing-diagnostic modals so a line is named the same way in both. These WIN over the engine's own
// description, because the engine names things for a pricing log ("Total cargo price") and repeats detail
// shown elsewhere in the UI ("Trailer (up to 5m)" beside a length sub-text or a configuration column).
// Anything NOT listed here falls through to the engine's description, which is how the per-type passenger
// rows (Passenger_A, Passenger_B, …) get "Adult x2" and the add-on rows get their option name.
export const PRICING_KEY_LABELS: Record<string, string> = {
	TotalCargo: 'Vehicle',
	AdditionalTowOnLength: 'Trailer',
	AdditionalCargoWidth: 'Vehicle width',
	AdditionalTowOnWidth: 'Trailer width',
	Passenger: 'Passengers',
	FreightBase: 'Freight',
	AddOn: 'Add-ons',
	ManagerDiscount: 'Manager discount',
	Discount: 'Discount',
};

/**
 * A listed key uses its label; everything else uses the engine's description, then the raw key. The
 * aggregate `Passenger` key only reaches this in the breakdown when a booking has no per-type split to
 * expand, so it keeps a generic label without hiding the "Adult x2" rows in the normal case.
 */
export function pricingLineLabel(key: string, description: string): string {
	return PRICING_KEY_LABELS[key] ?? (description?.trim() ? description : key);
}
